import axios from '../utils/request';

// import axios from '../utils/request';

export const createFile = ({ image, path } = {}) =>
  axios.post('/upload', {
    image,
    path,
  });

export const a = {};
